import estados from '@/assets/jsons/estados.json'
import FieldInput from '@/components/fields/FieldInput'
import FieldSelect from '@/components/fields/FieldSelect'
import FieldOptions from '@/components/fields/FieldOptions'

const required = true
const classCols2 = 'col-xs-12 col-sm-12 col-md-2 col-lg-2'
const classCols3 = 'col-xs-12 col-sm-12 col-md-3 col-lg-3'
const classCols4 = 'col-xs-12 col-sm-12 col-md-4 col-lg-4'
const classCols5 = 'col-xs-12 col-sm-12 col-md-5 col-lg-5'
const classCols6 = 'col-xs-12 col-sm-12 col-md-6 col-lg-6'
const classCols12 = 'col-xs-12 col-sm-12 col-md-12 col-lg-12'

const convertData = (val) => {
  if (!val) return ''
  const [ano, mes, dia] = val.split('-')
  return `${dia}/${mes}/${ano}`
}

const ufs = estados.map(({ sigla }) => ({ label: sigla, value: sigla }))

const findCities = (form, key) =>
  estados
    .filter(({ sigla }) => sigla === form?.[key])
    .flatMap(({ cidades }) => cidades.map((cidade) => ({ label: cidade, value: cidade })))

export const sections = [
  {
    titulo: 'Identificação do Candidato',
    icon: 'fas fa-user',
    class: classCols12,
    inputs: [
      { required, key: 'nome', type: 'text', label: 'Nome:', class: classCols4, component: FieldInput },
      { required, key: 'cpf', type: 'text', mask: '###.###.###-##', label: 'CPF:', class: classCols4, component: FieldInput },
      { required, key: 'rg', type: 'text', label: 'RG:', class: classCols5, component: FieldInput },
      { required, key: 'rg_orgao_emissor', type: 'text', label: 'Órgão Emissor:', class: classCols4, component: FieldInput },
      { key: 'rg_data_emissao', mask: '##/##/####', label: 'Data de Emissão:', class: classCols3, component: FieldInput, getconvert: convertData },
      { required, key: 'sexo', label: 'Sexo:', class: classCols4, component: FieldSelect, options: [{ label: 'Feminino', value: 'F' }, { label: 'Masculino', value: 'M' }] },
      { required, key: 'data_nascimento', mask: '##/##/####', label: 'Data de Nascimento:', class: classCols4, component: FieldInput, getconvert: convertData },
      { required, key: 'estado_civil', label: 'Estado Civil:', class: classCols4, component: FieldSelect, options: [{ label: 'Solteiro', value: 'solteiro' }, { label: 'Casado', value: 'casado' }, { label: 'Divorciado', value: 'divorciado' }, { label: 'Viúvo', value: 'viúvo' }] },
      { required, key: 'nacionalidade', type: 'text', label: 'Nacionalidade:', class: classCols6, component: FieldInput },
      {
        required,
        key: 'natural_uf',
        getkey: 'natural_uf',
        label: 'Natural da UF:',
        class: classCols3,
        options: ufs,
        component: FieldSelect
      },
      {
        required,
        key: 'natural_cidade',
        getkey: 'natural_cidade',
        label: 'Natural da cidade:',
        class: classCols5,
        options: (form) => findCities(form, 'natural_uf'),
        component: FieldSelect
      },
    ]
  },
  {
    titulo: 'Endereço',
    icon: 'fas fa-map-marker-alt',
    class: classCols12,
    inputs: [
      { required, key: 'cep', type: 'text', mask: '##.###-###', label: 'CEP:', class: classCols4, component: FieldInput },
      { required, key: 'endereco', type: 'text', label: 'Logradouro:', class: classCols6, component: FieldInput },
      { key: 'numero', type: 'text', label: 'Número:', class: classCols2, component: FieldInput },
      { key: 'complemento', type: 'text', label: 'Complemento:', class: classCols4, component: FieldInput },
      { required, key: 'bairro', type: 'text', label: 'Bairro:', class: classCols4, component: FieldInput },
      { required, key: 'uf', label: 'UF:', class: classCols2, options: ufs, component: FieldSelect },
      { required, key: 'cidade', label: 'Cidade:', class: classCols5, options: (form) => findCities(form, 'uf'), component: FieldSelect, taggable: true },
    ]
  },
  {
    titulo: 'Contato',
    icon: 'fas fa-phone',
    class: classCols12,
    inputs: [
      { required, key: 'telefone_celular', type: 'text', mask: '(##) #####-####', label: 'Celular:', class: classCols4, component: FieldInput },
      { key: 'telefone_residencial', type: 'text', mask: '(##) ####-####', label: 'Telefone Residencial:', class: classCols4, component: FieldInput },
      { key: 'telefone_comercial', type: 'text', mask: '(##) ####-####', label: 'Telefone Comercial:', class: classCols4, component: FieldInput },
      { required, key: 'email', type: 'email', label: 'Email:', class: classCols6, component: FieldInput },
      {
        required,
        key: 'repeatEmail',
        type: 'email',
        onPaste: false,
        hidePrint: true,
        label: 'Repita o Email:',
        class: classCols6,
        component: FieldInput
      },
      { required, key: 'senha', type: 'password', label: 'Senha:', class: classCols6, component: FieldInput },
      {
        required: true, // Campo obrigatório
        key: 'repeatSenha',
        type: 'password', // Campo para confirmar a senha
        label: 'Confirme a Senha:',
        class: classCols6, // Classes para layout responsivo
        component: FieldInput,
        placeholder: 'Repita sua senha'
      }
    ]
  },
  {
    titulo: 'Filiação',
    icon: 'fas fa-users',
    class: classCols12,
    inputs: [
      { required, key: 'nome_mae', type: 'text', label: 'Nome da Mãe:', class: classCols6, component: FieldInput },
      { key: 'nome_pai', type: 'text', label: 'Nome do Pai:', class: classCols6, component: FieldInput }
    ]
  },
  {
    titulo: 'Deficiência',
    hidden: true, // Esconder seção de deficiência
    icon: 'fas fa-wheelchair',
    class: classCols12,
    inputs: [
      { required, key: 'possui_deficiencia', label: 'Possui deficiência?', class: classCols6, component: FieldOptions, options: [{ label: 'Sim', value: 'S' }, { label: 'Não', value: 'N' }] },
      { key: 'detalhe_deficiencia', type: 'textarea', label: 'Detalhamento da deficiência:', class: classCols12, component: FieldInput, conditional: (form) => form.possui_deficiencia === 'S' }
    ]
  },
  {
    titulo: 'Condição Especial',
    hidden: true, // Esconder seção de condição especial
    icon: 'fas fa-universal-access',
    class: classCols12,
    inputs: [
      { required, key: 'possui_condicao_especial', label: 'Possui Condição Especial?', class: classCols6, component: FieldOptions, options: [{ label: 'Sim', value: 'S' }, { label: 'Não', value: 'N' }] },
      { key: 'detalhe_condicao_especial', type: 'textarea', label: 'Detalhamento da Condição Especial:', class: classCols12, component: FieldInput, conditional: (form) => form.possui_condicao_especial === 'S' }
    ]
  }
]
